import {CognitoAttributes, CognitoUser} from "./cognito-user.model";

export const initialCognitoUserState: CognitoUser = new CognitoUser({
  id: '',
  username:  '',
  attributes: {} as unknown as CognitoAttributes
});


